module.exports = __webpack_public_path__ + "static/img/screen-3-es.1e15591.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/how-it-works/screen-3-es.png
// module id = Wa7/
// module chunks = 0